import axios from 'axios';
import { View } from 'rune-ts';
import klass from '../view/SearchModuleUtil.module.scss';

interface ISearchModuleController {
  open(): void;
  close(): void;
  shake(): void;
  saveRecentSearch(search: string): Promise<void>;
  onMount(): void;
}

export class SearchModuleController implements ISearchModuleController {
  private onCloseCallback?: () => void;

  constructor(private readonly view: View) {}

  onMount(): void {
    // esc key 로 닫기
    document.addEventListener('keydown', (e) => {
      if (e.isComposing) {
        return;
      }
      if (e.key === 'Escape' || e.key === 'Esc') {
        this.close();
      }
    });
  }

  open() {
    if (this.onCloseCallback) {
      this.view.removeEventListener('transitionend', this.onCloseCallback);
      this.onCloseCallback = undefined;
    }

    this.view.element().classList.remove(klass.hiding);
    this.view.element().classList.remove(klass.hidden);
    this.view.element().classList.add(klass.visible);
  }

  close() {
    if (this.onCloseCallback) {
      this.view.removeEventListener('transitionend', this.onCloseCallback);
    }
    this.onCloseCallback = () => {
      this.view.element().classList.add(klass.hidden);
      if (this.onCloseCallback) {
        this.view.removeEventListener('transitionend', this.onCloseCallback);
        this.onCloseCallback = undefined;
      }
    };
    this.view.element().classList.remove(klass.visible);
    this.view.element().classList.add(klass.hiding);
    this.view.addEventListener('transitionend', this.onCloseCallback);
  }

  shake() {
    this.view.element().classList.add(klass.shake);
    setTimeout(() => {
      this.view.element().classList.remove(klass.shake);
    }, 300);
  }

  // 검색어 최근 검색어에 추가하고, 결과로 이동
  async saveRecentSearch(search: string) {
    // 최근 검색어 저장
    await axios.post(`/${ET.lang}/@api/keywords/history`, null, {
      params: { q: search },
    });
  }
}
